import { APIURLTypes } from '../enums/apiurltypes.enum';

export class APIUrlModel {
    constructor(public key: APIURLTypes, public part: string) {}
}
